<template>
    <div class="user-menu noselection" id="user-menu">
        <b-container >
            <b-row align-v="stretch" class="justify-content-md-between ml-0 mr-0">
                <div class="menu-clild" :key="item.id" v-for="item in menus" :class="[isActive(item.name)? 'active':'']" @click="setActive(item.name)">
                    <router-link :to="item.url">
                        <div class="menu-child-content">
                            <h1>{{ $t(item.label) }}</h1>
                        </div>
                        <div class="menu-child-image">
                            <b-img :src="item.icon" />
                        </div>
                    </router-link>              
                </div> 
            </b-row>
        </b-container>
    </div>
</template> 

<script>
    import Vue from "vue";
    export default {
        name: "user-menu",
        data() {
            return {
                //language: localStorage.getItem(Vue.Keys.LANGUAGE),
                language: Vue.i18n.locale(),
                activeMenu: this.$route.name,
                menus: [
                    {
                        id: 1,
                        name: "home",
                        label: "usermenu.mustknown",
                        icon: "img/icons/common/map-book.svg",
                        url: "/home"
                    },
                    {
                        id: 2,
                        name: "tools",
                        label: "usermenu.tools",
                        icon: "img/icons/common/tools.svg",
                        url: "/tools"
                    },
                    {
                        id: 3,
                        name: "share",
                        label: "usermenu.share",
                        icon: "img/icons/common/cog.svg",
                        url: "/share"
                    },
                    {
                        id: 4,
                        name: "cooptation",
                        label: "usermenu.cooptation",
                        icon: "img/icons/common/hands-helping.svg",
                        url: "/cooptation"
                    },
                    {
                        id: 5,
                        name: "actus",
                        label: "usermenu.news",
                        icon: "img/icons/common/megaphone.svg",
                        url: "/actus"
                    }
                ]
            };
        },
        methods: {
            isActive: function (menu) {
                return this.activeMenu === menu;
            },
            setActive: function (menu) {
                this.activeMenu = menu;
            }
        }        
    }
</script>
